import { defineComponent as _defineComponent } from 'vue'
import { User, } from "@/CodegenTypes";
import { mutations, queries } from "@/apollo";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { computed, onMounted, ref, watch } from "vue";
import { apolloClient } from "@/apollo";
import { addSuccessToast } from "@/vue-service";
import { useTranslation } from "@/store/translation";

export default /*#__PURE__*/_defineComponent({
  __name: 'IntakeSettingFormModal',
  props: {
    user: null,
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { user: User, value: boolean };


const form = ref(getDefaultForm());

const canIntake = computed(() => {

  const isMember = props.user.roleName === "member";
  return !isMember && props.user.ddCanIntake && props.user.ddIntake;
})

const { $t } = useTranslation();



onMounted(() => {
  resetForm()
})

function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    ddIntakeBig: props.user.ddIntakeBig,
    ddIntakeSmall: props.user.ddIntakeSmall,
    ddIntakeMethod: props.user.ddIntakeMethod,
  });
}

watch(() => (props.user), () => {
  resetForm();
})

function resetForm() {
  form.value = getDefaultForm();
}

const intakeMethodOptions = computed(() => {

  const isManager = props.user.roleName === "manager";
  const result = [
    { label: "Big Small", value: "bigSmall" },
    { label: "Priority Big", value: "priorityBig" },
    { label: "Priority Small", value: "prioritySmall" },
    { label: "Eat Big Turn Small", value: "eatBigTurnSmall" }
  ];
  if (isManager) {
    return result;
  } else {
    return result.filter(({ value }) => value !== "eatBigTurnSmall");
  }
})

async function handleSubmit() {
  try {
    const result = await apolloClient.mutate({
      mutation: mutations.updateOwnIntake,
      variables: {
        payload: {
          ddIntakeBig: form.value.ddIntakeBig,
          ddIntakeSmall: form.value.ddIntakeSmall,
          ddIntakeMethod: form.value.ddIntakeMethod,
        },
      },
      refetchQueries: [
        {
          query: queries.me,
        },
      ],
    });
    addSuccessToast("Intake setting updated.");
    toggleModal(false);
  } catch (err) {
    errorMutationNotification(err);
  }
}

return { __sfc: true,props, form, emit, canIntake, $t, toggleModal, getDefaultForm, resetForm, intakeMethodOptions, handleSubmit }
}

})